module.exports = __webpack_public_path__ + "static/media/notificacion_default.9a06b089.png";